export function prettyCurrency(number) {
  return isNaN(number) ? number : Number(number).toLocaleString('en-IN', {
    currency: 'INR',
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
